const sortAlpha = (a, b) => {
  if(a.label < b.label) { return -1; }
  if(a.label > b.label) { return 1; }
  return 0;
};

export const parseItems = (items) => {
  const arr = [...items];
  const newArr = arr.filter((item) => !!item.idNomeCampo);
  let result: any = [];
  result = newArr.map((item) => {
    return {
      name: item.idNomeCampo,
      key: item.descricao,
      label: item.idNomeCampo,
      checked: item.selecionado,
    };
  });
  const sorter = result.sort(sortAlpha);
  return sorter;
};
